module.exports = __webpack_public_path__ + "static/media/leaf_b2b.7acb6e1f.png";